import { useCallback, useMemo, useState } from "react";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { useMutation } from "@apollo/client";
import { REGISTER_AD_FROM_REGA } from "@/graphql/mutations/listing";
import { ErrorModal } from "@/components/error/ssr";
import css from "./.module.scss";
import { Button, Modal, Radio, Spinner } from "@aqar-app/react-ui";
import Head from "next/head";
import styles from "@/src/pages/add-rega-listing/addRegaListings.module.scss";
import { TestLicenses } from "@/components/add-v2/form/regaMapping";
import { useRouter } from "next/router";
import { InitialResolver } from "@/lib/use.middlewares";
import withAuthentication from "@/hoc/withAuthentication";
import { handleOnPasteCaptureNumbers } from "@/lib/numbersOnPase";
const dev = process.env.NODE_ENV === "development";

const AddRegaLicensePage = withAuthentication(function AddRegaLicensePage() {
  const [loading, setLoading] = useState(false);

  const router = useRouter();
  const { token } = useAuthState();
  const [licenseData, setLicenseData] = useState({
    ad_license_number: null,
    advertiser_id: null,
    id_type: null,
  });
  const [registerRegaListing] = useMutation(REGISTER_AD_FROM_REGA, {
    context: { token },
  });
  const isDevelopment = useMemo(() => {
    if (typeof window === "undefined") return dev;
    return location.href.startsWith("https://next.aqar.fm") || dev;
  }, []);

  const register = useCallback(function (data, onData) {
    const { ad_license_number, advertiser_id } = data;
    setLoading(true);
    setLicenseData({
      ad_license_number,
      advertiser_id,
      id_type: ad_license_number?.[1] || 1,
    });
    registerRegaListing({
      variables: {
        data: {
          ad_license_number,
          advertiser_id,
          id_type: ad_license_number?.[1] || 1,
        },
      },
    })
      .then(({ data }) => {
        onData(data?.RegaListing?.registerAdFromRega || {});
      })
      .catch((e) => {
        ErrorModal.handle(e, null);
      })
      .finally(() => setLoading(false));
  }, []);
  return (
    <div className={css.root}>
      <Head>
        <title>إضافة إعلان مرخص | عقار</title>
      </Head>
      <h1>رخصة إعلان</h1>
      <div className={css.form}>
        <p className={css.info}>
          بناء على نظام الوساطة العقارية لايمكن الاعلان في المنصات العقارية الا
          بوجود رخصة اعلان.
          <a
            href="https://aqr.to/ad-how-to"
            target="_blank"
            rel="noreferrer"
            className={styles.what}
          >
            ماهي رخصة الاعلان وكيفية الحصول عليها؟
          </a>
        </p>
        {isDevelopment && (
          <div className={css.group}>
            <p>للتطوير فقط</p>
            <Radio
              button
              onChange={(e, raw) => {
                register(raw, (data) => {
                  localStorage.setItem(
                    "newRegaListingDraft",
                    JSON.stringify({
                      ctx: { category: 0 },
                      regaResponse: data,
                    }),
                  );

                  return router.replace(`/add-listing/rega/summery`);
                });
              }}
              visibleOptions={3}
              name="test"
            >
              {TestLicenses.map(([ad_license_number, advertiser_id, label]) => (
                <Radio.Option
                  label={label}
                  value={ad_license_number}
                  raw={{ advertiser_id, ad_license_number }}
                />
              ))}
            </Radio>
          </div>
        )}
        <div className={css.group}>
          <p>رقم ترخيص الإعلان</p>
          <input
            inputMode="numeric"
            onPasteCapture={handleOnPasteCaptureNumbers}
            onKeyDown={(e) => {
              if (
                e.ctrlKey ||
                e.metaKey ||
                e.key === "Tab" ||
                e.key === "Backspace"
              )
                return;

              const nextValue = e.target.value + e.key;

              if (Number.isNaN(+nextValue)) return e.preventDefault();
            }}
            onChange={(e) => {
              if (e.target.value.length > 10) return;
              setLicenseData({
                ...licenseData,
                ad_license_number: e.target.value,
                id_type: licenseData.ad_license_number?.[1] || 1,
              });
            }}
            value={licenseData.ad_license_number}
          />
        </div>
        {licenseData.ad_license_number?.length > 9 && (
          <div className={css.group}>
            <p>
              {licenseData?.id_type + "" === "1"
                ? "رقم هوية المعلن"
                : "رقم سجل المنشأة"}
            </p>
            <input
              inputMode="numeric"
              onPasteCapture={handleOnPasteCaptureNumbers}
              onKeyDown={(e) => {
                if (
                  e.ctrlKey ||
                  e.metaKey ||
                  e.key === "Tab" ||
                  e.key === "Backspace"
                )
                  return;
                const nextValue = e.target.value + e.key;
                if (Number.isNaN(+nextValue)) return e.preventDefault();
              }}
              onChange={(e) => {
                if (e.target.value.length > 10) return;
                setLicenseData({
                  ...licenseData,
                  advertiser_id: e.target.value,
                });
              }}
              value={licenseData.advertiser_id}
            />
          </div>
        )}
        <div className={css.group}>
          <Button
            className={css.next}
            disabled={
              loading ||
              !licenseData.ad_license_number ||
              licenseData.ad_license_number.length < 10 ||
              !licenseData.advertiser_id ||
              licenseData.advertiser_id.length < 10
            }
            onClick={() => {
              register(licenseData, (data) => {
                localStorage.setItem(
                  "newRegaListingDraft",
                  JSON.stringify({
                    ctx: {
                      category: 0,
                    },
                    regaResponse: data,
                  }),
                );

                return router.replace(`/add-listing/rega/summery`);
              });
            }}
            theme="primary"
          >
            {loading ? <Spinner size="small" /> : null}
            التالي
          </Button>
        </div>
      </div>
    </div>
  );
});
AddRegaLicensePage.getInitialProps = InitialResolver();
export default AddRegaLicensePage;
